import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Parallax } from 'react-scroll-parallax';
import queryString from 'query-string';

import Layout from '../ui/Layout';
import ContactForm from './contactUs/ContactForm';
import fetchDux from '../../state/fetch-dux';

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = { isPreview: false };
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    const qs = queryString.parse(this.props.location.search) || {};
    this.props.getContent({
      page: 'contact-us',
      preview: qs.preview
    });
    this.setState({ isPreview: !!qs.preview });
  }
  componentWillUnmount() {
    const { clearGetContent, clearSubmitForm } = this.props;
    clearGetContent();
    clearSubmitForm();
  }
  render() {
    const { result, submitForm, submitResult, error } = this.props;
    const { isPreview } = this.state;
    const { data, versionName } = result || {};
    const { image } = data || {};
    const { href } = image || {};
    const handleSubmit = values => {
      const { contactType } = values;
      submitForm(
        Object.assign({}, values, {
          contactType: Object.keys(contactType)
        })
      );
    };
    return (
      <Layout
        route="contact-us"
        isPreview={isPreview}
        versionName={versionName}
      >
        <main>

          <section className="box-map">
            <div
              className="image"
              style={{ backgroundImage: `url(${href})` }}
            />
            <div className="map" />
            <div className="text left">Napa Valley, CA</div>
            <div className="text right">we measure phenolics</div>
            <div className="text bottom">
              Latitude: 38.224327 | Longitude: -122.264946
            </div>
            <Parallax offsetYMax={10} offsetYMin={-10} className="triangle" />
          </section>

          <Grid>
            <Row>
              <Col sm={12}>

                <section className="box-form">

                  <h2>Let’s Work Together</h2>

                  {!submitResult &&
                    <ContactForm onSubmit={handleSubmit} message={error} />}
                  {submitResult &&
                    <div className="confirmation">
                      <p>
                        Thank you for contacting us,
                        <br />
                        we will be in touch soon.
                      </p>
                      <Link to="/knowledge-center">
                        Explore our knowledge center
                      </Link>
                    </div>}

                  <Parallax
                    offsetYMax={10}
                    offsetYMin={-10}
                    className="bottle"
                  />
                  <Parallax
                    offsetYMax={20}
                    offsetYMin={-20}
                    className="cork-screw"
                    slowerScrollRate
                  />

                </section>

              </Col>
            </Row>
          </Grid>

        </main>
      </Layout>
    );
  }
}

const mapState = state => {
  const { result } = state.getContent.toJS();
  const { error, result: submitResult } = state.postContactForm.toJS();
  return { result, submitResult, error: (error || {}).message };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      submitForm: fetchDux.postContactForm.createAction,
      clearSubmitForm: fetchDux.postContactForm.clearAction,
      getContent: fetchDux.getContent.createAction,
      clearGetContent: fetchDux.getContent.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(ContactUs);



// WEBPACK FOOTER //
// ./src/components/routes/ContactUs.js